import { canSetIntendedUse, destinationReason, isDirty } from './inventoryModel.mjs';

// One explicit click owns the whole save -> draft sequence. The lock starts
// before the first await, including time spent waiting for a batch slot.
export function createShopifySender({ findRow, changeRow, save, destination, enqueue, getGeneration }) {
  const pending = new Map();
  return function sendToShopify(cert) {
    const key = cert.toUpperCase();
    if (pending.has(key)) return pending.get(key);
    const row = findRow(cert);
    const reason = !row ? 'Slab no longer available.'
      : !canSetIntendedUse(row) ? 'This slab cannot be moved right now.'
      : row.lookup !== 'ready' ? 'Wait for the slab lookup to finish.'
      : row.saveUncertain || row.saveConflict || row.remoteMissing || row.saving ? 'Check the saved inventory record before sending to Shopify.'
      : row.destinationUncertain ? 'Check the previous Shopify request before trying again.' : '';
    if (reason) {
      if (row) changeRow(cert, item => ({ ...item, notice: reason }));
      return Promise.resolve({ status: 'review_required', message: reason });
    }
    const generation = getGeneration();
    const current = () => generation === getGeneration() && Boolean(findRow(cert));
    changeRow(cert, item => ({ ...item, routing: 'shopify', intendedUseDraft: 'shopify', intendedUseTouched: true, notice: '' }));
    const operation = Promise.resolve().then(() => enqueue(async () => {
      if (!current()) return { status: 'cancelled' };
      if (isDirty(findRow(cert)) && !await save(cert)) return { status: 'save_required' };
      if (!current()) return { status: 'cancelled' };
      const saved = findRow(cert);
      const blocked = saved.intendedUseDraft !== 'shopify' ? 'Destination changed while saving. Nothing sent to Shopify.'
        : destinationReason(saved, 'shopify');
      if (blocked) {
        changeRow(cert, item => ({ ...item, notice: blocked }));
        return { status: 'review_required', message: blocked };
      }
      return destination(cert, 'shopify');
    })).finally(() => {
      if (current()) changeRow(cert, item => ({ ...item, routing: '' }));
      pending.delete(key);
    });
    pending.set(key, operation);
    return operation;
  };
}
